import { Autocomplete,Select, MenuItem, RadioGroup, Radio, FormControlLabel, FormControl, FormLabel, Typography, TextField } from "@mui/material";
import React, {useEffect, useState} from "react";

import { CheckCircle, Error } from "@mui/icons-material";
import { KeyboardDatePicker } from "@material-ui/pickers";

const AddEquipmentRow = (props) => {
    let [name, setName] = useState()
    let [type, setType] = useState(props.typeDefault)
    let [system, setSystem] = useState()
    let [product, setProduct] = useState()
    let [installedDate, setInstalledDate] = useState(new Date())
    let [showExisting, setShowExisting] = useState(true)
    let [showNew, setShowNew] = useState(false)
    let [company, setCompany] = useState()
    let [model, setModel] = useState()

    let brickTypeOptions = props.equipmentTypes;
    let systemOptions = props.systems;
    let products = props.products;

    const updateForm = () => {
        let equipment = Object.assign({}, props.equipment)
        equipment.element_id = props.elementId;
        equipment.name = name;
        equipment.type = type;
        equipment.system = system;
        equipment.installed_date = installedDate;
        equipment.product_id = null

        let equipmentProduct = product ? product : company && model ? {
            company: company,
            model: model,
            type: equipment.type
        } : null
        equipment.product = equipmentProduct

        props.callback(props.row_num, equipment)
    }

    useEffect(() => {
        updateForm();
    },[name, type, system, product, installedDate, company, model])

    let className = props.equipment.error ? "add-row row-toast" : "add-row" 
    return (
        <div className={className}>
            <div className="row-error">{props.equipment.error}</div>
            <div className="row-form-field">
                <TextField label="Name" variant="outlined" size="small" onChange={(e) => {setName(e.target.value)}} required/>
            </div>
            <div className="row-form-field">
                <Autocomplete
                        disablePortal
                        id="systemOptions"
                        size="small"
                        options={systemOptions || []}
                        getOptionLabel={option => option.name}
                        style={{ minWidth: "200px" }}
                        fullWidth
                        renderInput={(params) => <TextField {...params} label="System" variant="outlined" size="small" />}
                        groupBy={(option) => option.parent}
                        onChange={(event, newValue) => {
                            setSystem(newValue.brick_system_type)
                        }}
                    />
            </div>
            <div className="row-form-field">
                <Autocomplete
                        disablePortal
                        id="equipmentTypeOptions"
                        size="small"
                        options={brickTypeOptions}
                        getOptionLabel={option => option.name}
                        groupBy={(option) => option.parent}
                        style={{ minWidth: "200px" }}
                        fullWidth
                        renderInput={(params) => <TextField {...params} label="Type" variant="outlined" size="small" required />}
                        onChange={(event, newValue) => {
                            setType(newValue.brick_equipment_type)
                        }}
                    />
            </div>
            <div className="row-form-field">
                <KeyboardDatePicker
                    autoOk
                    options={[]}
                    variant="inline"
                    inputVariant="outlined"
                    label="Installed Date"
                    format="MM/dd/yyyy"
                    size={"small"}
                    value={installedDate}
                    InputAdornmentProps={{ position: "start" }}
                    onChange={(date) => {setInstalledDate(date)}}
                />
            </div>
            <div className="row-form-field">
                    <RadioGroup defaultValue="existing" name="product-group" row>
                        <FormControlLabel value="existing" control={<Radio size="small"/>} label={<Typography sx={{ fontSize: 12 }}>Existing </Typography>}  onClick={() => { setShowExisting(true); setShowNew(false); setProduct(null); }}/>
                        <FormControlLabel value="new" control={<Radio size="small"/>} label={<Typography sx={{ fontSize: 12 }}>New</Typography>}  onClick={() => { setShowExisting(false); setShowNew(true); setProduct(null); }} />
                        <FormControlLabel value="unknown" control={<Radio size="small"/>} label={<Typography sx={{ fontSize: 12 }}>Unknown</Typography>} onClick={() => { setShowExisting(false); setShowNew(false); setProduct(null);}}/>
                        {
                            showExisting ?
                                <Autocomplete
                                    disablePortal
                                    id="product"
                                    size={"small"}
                                    options={products || []}
                                    getOptionLabel={option => option.label}
                                    fullWidth
                                    renderInput={(params) => <TextField {...params} label="Product" variant="outlined" required />}
                                    onChange={(event, newValue) => {
                                        setProduct(newValue)
                                    }}
                                /> : null
                        }
                        {
                            showNew ?
                                <div className="add-product-row">
                                    <TextField label="Company" variant="outlined" size="small" onChange={(e) => {setCompany(e.target.value)}}/>
                                    <TextField label="Model" variant="outlined" size="small" onChange={(e) => {setModel(e.target.value)}}/>
                                </div>: null
                        }
                    </RadioGroup>
            </div>
            {
                props.equipment.success ?
                <div className="success-indicator">
                        <CheckCircle /> 
                </div> : props.equipment.success == false ?
                <div className="failure-indicator">
                        <Error /> 
                </div> : <div className="failure-indicator">

                </div>  
            }

        </div>
    )
}

export default AddEquipmentRow;